import { useTheme, type ThemeChoice } from "../../lib/theme";

const NEXT: Record<ThemeChoice, ThemeChoice> = {
  system: "light",
  light: "dark",
  dark: "system",
};

const LABEL: Record<ThemeChoice, string> = {
  system: "System",
  light: "Light",
  dark: "Dark",
};

export function ThemeToggle() {
  const { choice, setChoice } = useTheme();
  return (
    <button
      type="button"
      onClick={() => setChoice(NEXT[choice])}
      className="rounded-full px-3 py-1.5 text-sm text-ink-muted hover:text-ink"
      aria-label={`Appearance: ${LABEL[choice]}. Activate to change.`}
    >
      {LABEL[choice]}
    </button>
  );
}
